<ion-datetime
    class="date-time-picker"
    #datetimePicker
    *ngIf="canRenderDatetime"
    [value]="normalizedValue"
    [disabled]="disabled"
    [firstDayOfWeek]="firstDayOfWeek"
    [min]="normalizedMin"
    [max]="normalizedMax"
    [presentation]="presentationMode"
    [preferWheel]="env?.ENABLE_WHEEL_DATE_TIME_PICKER === true"
    [color]="color"
    [locale]="locale"
    [hourCycle]="hourCycle"
    [size]="size"
    [showDefaultButtons]="showDefaultButtons"
    (ionChange)="handleIonChange($event)"
    (ionFocus)="handleIonFocus($event)"
    (ionBlur)="handleIonBlur()">
    <ng-content></ng-content>
</ion-datetime>
